var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeactiveateUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0C4.25322 0 0 4.25322 0 9.5C0 14.7468 4.25322 19 9.5 19C14.7468 19 19 14.7468 19 9.5C19 4.25322 14.7468 0 9.5 0ZM3.47117 13.2432C3.37577 13.0896 3.2857 12.9317 3.20221 12.7704C2.72401 11.8527 2.44083 10.8192 2.40714 9.72225C2.28338 5.70776 5.5503 2.36724 9.56635 2.40402C10.7216 2.41437 11.8106 2.70138 12.7716 3.20102C12.9329 3.28492 13.0904 3.37499 13.244 3.47077C13.3138 3.51407 13.3253 3.611 13.2674 3.66886L3.66963 13.2666C3.61178 13.3245 3.51485 13.313 3.47117 13.2432ZM9.5 16.5964C8.32022 16.5964 7.20787 16.3082 6.22962 15.799C6.06831 15.7151 5.91008 15.625 5.75641 15.5296C5.68627 15.4859 5.6748 15.389 5.73266 15.3311L15.3311 5.73266C15.389 5.6748 15.4859 5.68631 15.5296 5.75641C15.625 5.91008 15.715 6.06831 15.799 6.22962C16.3082 7.20902 16.5964 8.32022 16.5964 9.5C16.5964 13.4191 13.4202 16.5964 9.5 16.5964Z",
    fill: "#CC5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.934 1.70654C17.0211 3.44883 18.3488 6.07012 18.3488 9.00176C18.3488 14.2485 14.0956 18.5018 8.84882 18.5018C6.82836 18.5018 4.95463 17.8707 3.41504 16.7951C5.06307 18.1719 7.18505 18.9999 9.5002 18.9999C14.747 18.9999 19.0002 14.7467 19.0002 9.49988C19.0002 6.27396 17.3924 3.42352 14.934 1.70654Z",
    fill: "#CC5A5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_88"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactiveateUser);
export default __webpack_public_path__ + "static/media/deactiveate-user.2899a6001fbaf24bcf664a0f76e7d48b.svg";
export { ForwardRef as ReactComponent };